import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/FileDownloader`,
  scopes: ExtHubRequest,
});

api.createEntities([{ name: 'getPdf' }]);

const GetPdfData = ({ folder, document }) =>
  api
    .createBasicCRUDEndpoints('EncodeFolderAndDoc', undefined, undefined, true)
    .post({ folder, document });
const GetPdfFile = ({ folder, document }) =>
  api.createBasicCRUDEndpoints(`getPDF/${folder}/${document}`, undefined, undefined, true).get();
const GetFile = (path) =>
  api.createBasicCRUDEndpoints(`getFile?path=${path}`, undefined, undefined, true).get();

export { GetPdfData, GetPdfFile, GetFile };
